import React from 'react';
import '../styles/Results.css';

const Results = () => {
  return (
    <div className="results-page">
      <h1>Results History</h1>
      <p>Results history view coming soon...</p>
    </div>
  );
};

export default Results;
